import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { APP_FILE_ACCOUNT_PAYABLE_REPORT } from "../Acoounting.constants";
import { MODULE_IDS } from "../../../constants/enums";

const AccountPayableReport = Loadable(
  lazy(() =>
    import("./AccountPayableReport").then(({ AccountPayableReport }) => ({
      default: AccountPayableReport,
    }))
  )
);


export const AccountPayableReportRouter = [
  {
    path:  `${APP_FILE_ACCOUNT_PAYABLE_REPORT}`,
    exact: true,
    element: (
      <AuthorizedRoute  moduleKeys={[MODULE_IDS.REPORTS_ACCOUNTS_PAYABLE]}>
        <AccountPayableReport />
      </AuthorizedRoute>
    ),
  },
  
];
